module.exports = __webpack_public_path__ + "img/sbl0012.22cefde8.png";